export const initSelect = ($selects) => {
	$selects.each(function(index, el) {
		const $select = $(el);
		const $parent = $select.parent();

		$select.on('change', function() {
			$(this).closest('.select').removeClass('clean-select');
		});

		$select.select2({
			width: '100%',
			minimumResultsForSearch: -1,
			dropdownParent: $parent,
		});

		$parent.find('.select2-selection__rendered').removeAttr('role');
	});
}

export default function selectsUI() {
	initSelect($('.select select'));
}
